import DefaultDashboardPanel from "./defaultDashboardPanel.container";

export default DefaultDashboardPanel;
